import React, { useEffect } from 'react';
import { createPortal } from 'react-dom';
import PropTypes from 'prop-types';
import PopupOverlay from '../../organisms/Background/PopupOverlay';

// The same domain form can live in a modal or in Discover's map panel.
export default function EntityFormSurface({
    embedded = false,
    busy = false,
    onBusyChange,
    onClose,
    closeOnEsc,
    children,
}) {
    useEffect(() => {
        onBusyChange?.(busy);
    }, [busy, onBusyChange]);

    useEffect(() => () => onBusyChange?.(false), [onBusyChange]);

    if (embedded) return <>{children}</>;

    const overlay = (
        <PopupOverlay onClose={onClose} closeOnOverlayClick={!busy} closeOnEsc={closeOnEsc}>
            {children}
        </PopupOverlay>
    );
    const portalTarget = typeof document !== 'undefined' ? document.getElementById('portal') : null;
    return portalTarget ? createPortal(overlay, portalTarget) : overlay;
}

EntityFormSurface.propTypes = {
    embedded: PropTypes.bool,
    busy: PropTypes.bool,
    onBusyChange: PropTypes.func,
    onClose: PropTypes.func.isRequired,
    closeOnEsc: PropTypes.bool,
    children: PropTypes.node.isRequired,
};
